class FetchOrganizations {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchOrganizations;
